import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from './url.service';
import { Observable } from 'rxjs';
import { ResultForGraphDisplayDto } from 'app/@types/dto/result-for-graph-display-dto.model';
import { ResultExportRequestDto } from 'app/@types/dto/result-export-request-dto.model';
import { ExportType } from 'app/@types/shared/export-type-enum';

@Injectable({
    providedIn: 'root',
})
export class ResultHttpService {
    constructor(
        private http: HttpClient,
        private urlService: UrlService,
    ) {}

    //Get combined results
    getCombinedResults(orgId: string, lang: string): Observable<ResultForGraphDisplayDto[]> {
        return this.http.get<ResultForGraphDisplayDto[]>(this.urlService.getCombinedResults(orgId, lang));
    }

    //Export results
    getExportResults(
        orgId: string,
        lang: string,
        year: number,
        exportType: ExportType,
        request: ResultExportRequestDto,
    ): Observable<Blob> {
        return this.http.post(this.urlService.getExportResultsUrl(orgId, lang, year, exportType), request, {
            responseType: 'blob',
        });
    }
}
